export default __webpack_public_path__ + "img/4071c84723f8d6b26c20fa03daa0f7a1.png";